import { isPast, isValid } from 'date-fns';
import { FormattedMessage, defineMessages } from 'react-intl';

import { Props } from '@sorare/core/src/components/cardswap/Banner';

import { GenericBanner } from '../GenericBanner';
import { CardSwapIcon } from './icon';

const messages = defineMessages({
  title: {
    id: 'HomepageCardSwap.Banner.title',
    defaultMessage: 'Card Swap',
  },
  explanation: {
    id: 'HomepageCardSwap.Banner.explanation',
    defaultMessage: 'Trade in one Common Card for a new one.',
  },
  cta: {
    id: 'HomepageCardSwap.Banner.cta',
    defaultMessage: 'Claim',
  },
  timeLeft: {
    id: 'HomepageCardSwap.TimeUntilNext.timeLeft',
    defaultMessage: 'Free swap in {timeLeft}',
  },
});

export const CardSwapBanner = ({
  tradeInProgress,
  nextTradeAvailable,
  onClick,
}: Props) => {
  if (!isValid(nextTradeAvailable)) return null;

  const isTradeAvailable = tradeInProgress || isPast(nextTradeAvailable);
  return (
    <GenericBanner
      icon={<CardSwapIcon />}
      title={<FormattedMessage {...messages.title} />}
      subtitle={<FormattedMessage {...messages.explanation} />}
      cta={<FormattedMessage {...messages.cta} />}
      timeLeftMessage={messages.timeLeft}
      isAvailable={isTradeAvailable}
      nextAvailableDate={nextTradeAvailable}
      onClick={onClick}
    />
  );
};
